<template>
  <div>
    <div class="p-4 #9 m:#8 l:#7 Case o-7 b b-j-sb b-a-c">
      <div class="unt-n">
        <i class="material-icons m-e-4">explore</i>{{ $t('posts') }}
      </div>
    </div>
    <div class="rlt">
      <transition name="fade">
        <div v-if="loading">
          <div class="b b-c -r-c abs .f -z-2">
            <div class="abs .f c20 o-7"></div>
            <svg class="prgc prg-inf" viewBox="0 0 38 38">
              <circle cx="50%" cy="50%" r="18" />
            </svg>
          </div>
        </div>
      </transition>
      <div style="--grdnt-end:currentColor; background-image: linear-gradient(to right, currentcolor 0%, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0));" class="abs .f -grdnt-r l20-t d1-t -z-1 -pe-n -en-x"></div>
      <div class="b w-f -o-x-a">
        <div class="x8 l:x5 b-fs" v-for="(post, index) in posts" :key="index">
          <div class="p-4">
            <a :href="post.link" target="_blank" style="color: currentColor;">
              <div class="-r-l -o-h -b-1 c18-b">
                <div class="rlt b -r-i r-1:1">
                  <img class="r w-f -r-i -img-cv" :src="post.better_featured_image.source_url" />
                  <div
                    class="abs .f -grdnt-b l20-t d1-t"
                    style="--grdnt-end:currentColor; background-image: linear-gradient(to top, currentcolor 35%, rgba(255, 255, 255, 0));"
                  ></div>
                  <div class="p-5 abs .b-n">
                    <div class="#11 m:#10 l:#9 Case">{{ post.title.rendered }}</div>
                    <div class="#12 m-t-5 o-5 CASE font-en">{{ post.date }}</div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
const axios = require('axios')

export default {
  name: 'PostsWidget',
  computed: {
    ...mapState(['countriesData']),
    ...mapGetters(['getSelectedCountries', 'getSelectedCountriesTotal'])
  },
  data () {
    return {
      loading: false,
      posts: [],
      max: 10
    }
  },
  methods: {
    loadPosts () {
      // https://arbheal.com/wp-json/wp/v2/posts?per_page=10
      axios.get('https://arbheal.com/wp-json/wp/v2/posts?per_page=15').then((resp) => {
        this.loading = false
        this.posts = resp.data
      })
    }
  },
  mounted () {
    this.loadPosts()
  }
}
</script>
